export const CREATE_ORGANIZATION_MODAL = 'create_organization_modal';
export const LOGOUT_CONFIRMATION_MODAL = 'logout_confirmation_modal';
